import dynamicModuleRegistery from 'dynamic-module-registry';

// The 'isFromSecondLoanFlow' check is used to determine if the user is from second loan (https://github.tlcinternal.com/Release/borrower-apply-ui/blob/release/188/src/pages/pi1-1QAAT/utils/flow-definition.js#L30)
// Moving this check to PI1 so that this value is logged to Heap as well.
export const exp = dynamicModuleRegistery.get('optimizelyExperience') || {};

export default {
  agreementLinks: dynamicModuleRegistery.get('agreementLinks'),
  prequal: dynamicModuleRegistery.get('prequal'),
  repeatsContext: dynamicModuleRegistery.get('repeatsContext'),
  dm: dynamicModuleRegistery.get('dm'),
  autoCompleteConfig: dynamicModuleRegistery.get('autoCompleteConfig'),
  experiments: exp,
  borrowerStates: dynamicModuleRegistery.get('borrowerStates'),
  environment: dynamicModuleRegistery.get('environment') || {},
  lockedPI1Context: dynamicModuleRegistery.get('lockedPI1Context') || {},
  isLoggedIn: dynamicModuleRegistery.get('isLoggedIn'),
  primaryBorrower: dynamicModuleRegistery.get('primaryBorrower') || {}, // to mock RMEJA, set this to {firstName: 'first', lastName: 'last'}, and isFromSecondLoanFlow = true, isRMEJA = true
  previousSecondaryBorrower: dynamicModuleRegistery.get('previousSecondaryBorrower') || {},
  isFromSecondLoanFlow: !!dynamicModuleRegistery.get('isFromSecondLoanFlow'),
  isRMEJA: dynamicModuleRegistery.get('isRMEJA'),
  hasExtoleReferrer: dynamicModuleRegistery.get('hasExtoleReferrer'),
  heapTrackingPage: dynamicModuleRegistery.get('heapTrackingPage'),
  higherLoanAmountContext: dynamicModuleRegistery.get('higherLoanAmountContext'),
};

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/pi1-1QAAT.scss');